import { render, staticRenderFns } from "./InstanceAvatar.vue?vue&type=template&id=7e5ea80a&scoped=true"
import script from "./InstanceAvatar.vue?vue&type=script&lang=js"
export * from "./InstanceAvatar.vue?vue&type=script&lang=js"
import style0 from "./InstanceAvatar.vue?vue&type=style&index=0&id=7e5ea80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5ea80a",
  null
  
)

export default component.exports